"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AutocompleteBase = _interopRequireDefault(require("./AutocompleteBase"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

var _IconFieldData = _interopRequireDefault(require("./IconField.data.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const getOptions = () => {
  let options = [];

  _IconFieldData.default.categories.map(category => {
    category && category.icons && category.icons.map(icon => {
      options.push({
        group: category.name,
        label: category.name + "/" + icon.name,
        value: icon.ligature
      });
    });
  });

  return options;
};

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    "& * + *": {
      marginLeft: theme.spacing(2)
    }
  },
  icon: {},
  label: {
    fontFamily: "Akkurat, sans-serif"
  }
}));

const IconFieldOption = ({
  value,
  label
}) => {
  const classes = useStyles();
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement(_Icon.default, {
    className: classes.icon
  }, value), _react.default.createElement(_Typography.default, {
    className: classes.label
  }, label));
};

const IconField = ({
  id,
  label = "Select icon",
  helperText,
  value,
  required,
  disabled,
  readonly,
  multiple,
  autofocus,
  onChange,
  onBlur,
  onFocus,
  placeholder
}) => {
  const emptyValue = multiple ? [] : "";
  const options = getOptions();

  const handleChange = (event, option) => {
    onChange(option.value, event);
  };

  const renderOption = (option, state) => {
    return _react.default.createElement(IconFieldOption, option);
  };

  return _react.default.createElement(_AutocompleteBase.default, {
    id: id,
    placeholder: placeholder,
    multiple: multiple,
    options: options,
    groupBy: option => option.group,
    icon: value || "search",
    label: label,
    helperText: helperText,
    value: typeof value === "undefined" ? emptyValue : value,
    required: required,
    disabled: disabled || readonly,
    autoFocus: autofocus,
    renderOption: renderOption,
    onChange: handleChange
  });
};

IconField.defaultProps = {
  autofocus: false
};
IconField.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  helperText: _propTypes.default.string,
  value: _propTypes.default.any,
  required: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readonly: _propTypes.default.bool,
  multiple: _propTypes.default.bool,
  autofocus: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func
} : {};
var _default = IconField;
exports.default = _default;
module.exports = exports.default;